import { render } from "./Paginaiton.vue?vue&type=template&id=4f0c98e3"
import script from "./Paginaiton.vue?vue&type=script&lang=js"
export * from "./Paginaiton.vue?vue&type=script&lang=js"

import "./Paginaiton.vue?vue&type=style&index=0&id=4f0c98e3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__